import { ISortable } from "../../helpers/sort";
import { SortItem } from "../ss-api/responses/member.dashboard.license.response";

export interface IProductSettingsBase  {
    ID: number;
    Name: string;
    IsRecurringBilling: number;
    MonthlyPriceSetup: number;
    MonthlyPrice: number;
    YearlyPriceSetup: number;
    YearlyPrice: number;
    YardIsRecurringBilling: boolean;
}

export interface IProductSettings extends IProductSettingsBase  {  
    Yard: boolean;
    YardMonthlyPriceSetup: number;
    YardMonthlyPrice: number;
    YardYearlyPriceSetup: number;
    YardYearlyPrice: number;
    Addons: IProductSettingsBase[];
}

export class ProductSettingsItemArray extends Array<ProductSettings> implements ISortable {
    
    public LastSort = new SortItem;

    constructor(...items: ProductSettings[]) {
        super(...items);
        Object.setPrototypeOf(this, ProductSettingsItemArray.prototype);
    }

}

export class ProductSettingsBase  implements IProductSettingsBase {
    ID: number;
    Name: string;
    VisiblePublic: boolean;
    IsRecurringBilling: number;
    YardIsRecurringBilling: boolean;
    MonthlyPriceSetup: number;
    MonthlyPrice: number;
    YearlyPriceSetup: number;
    YearlyPrice: number;
}


export class ProductSettings  implements IProductSettings {
    ID: number;
    Name: string;
    VisiblePublic: boolean;
    IsRecurringBilling: number;
    YardIsRecurringBilling: boolean;
    MonthlyPriceSetup: number;
    MonthlyPrice: number;
    YearlyPriceSetup: number;
    YearlyPrice: number;
    Yard: boolean;
    YardVisiblePublic: boolean;
    YardMonthlyPriceSetup: number;
    YardMonthlyPrice: number;
    YardYearlyPriceSetup: number;
    YardYearlyPrice: number;
    Addons: ProductSettingsBase[];
}
